import PropTypes from 'prop-types';
import { CustomCheckbox } from '../../../../form/custom_checkbox';
import Translation from '../../../../translation/translation';
import { isNzStore } from '../../../../../../_views/configurator/common';

function IncludedServices(props) {
  return (
    <div className="fsf-station__detail">
      <h3 className="fsf-station__detail-headline">
        <Translation translationKey="fitting-station-finder-app-services" />
      </h3>
      <div className="fsf-station__detail-contents">
        {props.vehicleCollectAndReturnService && (
          <p className="fsf-services">
            <span className="fsf-services__tag tag tag--included">
              <CustomCheckbox additionalContainerClasses={['tag__choose']} disabled={true} checked={true} />
              <label className="tag__label">
                <span className="simple-tag">
                  <Translation translationKey="fitting-station-finder-app-collect-fit-return-fs-detail" />
                </span>
              </label>
              <span className="tag__price">
                <Translation translationKey="fitting-station-finder-app-service-free" />
              </span>
            </span>
          </p>
        )}
        {props.vehicleCollectAndReturnService && (
          <p className="fsf-services-note">{props.vehicleCollectAndReturnServiceComment}</p>
        )}
        <p className="fsf-services">
          <span className="fsf-services__tag tag tag--included">
            <CustomCheckbox additionalContainerClasses={['tag__choose']} disabled={true} checked={true} />
            <label className="tag__label">
              <span className="simple-tag">
                <Translation translationKey="fitting-station-finder-app-balancing" />
              </span>
            </label>
            <span className="tag__price">
              <Translation translationKey="fitting-station-finder-app-service-free" />
            </span>
          </span>
          <span className="fsf-services__tag tag tag--included">
            <CustomCheckbox additionalContainerClasses={['tag__choose']} disabled={true} checked={true} />
            <label className="tag__label">
              <span className="simple-tag">
                <Translation translationKey="fitting-station-finder-app-tyre-disposal" />
              </span>
            </label>
            <span className="tag__price" style={{ width: '165px' }}>
              <Translation
                translationKey={
                  !isNzStore(TYROOLA.globals.store)
                    ? 'fitting-station-finder-app-service-free'
                    : 'fitting-station-finder-app-service-included-in-tyre-stewardship-fee'
                }
              />
            </span>
          </span>
        </p>
      </div>
    </div>
  );
}

IncludedServices.propTypes = {
  vehicleCollectAndReturnService: PropTypes.bool,
  vehicleCollectAndReturnServiceComment: PropTypes.string,
};

IncludedServices.defaultProps = {
  vehicleCollectAndReturnService: false,
  vehicleCollectAndReturnServiceComment: '',
};

export default IncludedServices;
